import { IAddonCommonsCMS } from '@vfit/consumer/data-access';

export const evaluateCommonLabels = (cmsData: IAddonCommonsCMS) => ({
  title: cmsData?.addoncommons?.addonStep?.topText || '',
  ctaLabel: cmsData?.addoncommons?.addonStep?.skipCtaLabel || '',
});

